import React from 'react'
import { MqDesktop } from 'streamr-ui/css/consts'
import styled from 'styled-components'

const GitHub = ({ className }) => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className}>
        {/* eslint-disable-next-line max-len */}
        <path
            d="M11.999 0C5.373 0 0 5.279 0 11.791c0 5.21 3.438 9.629 8.207 11.188.6.109.819-.255.819-.568 0-.28-.01-1.021-.017-2.005-3.337.712-4.042-1.581-4.042-1.581-.546-1.362-1.332-1.725-1.332-1.725-1.09-.731.082-.717.082-.717 1.205.084 1.838 1.216 1.838 1.216 1.07 1.801 2.81 1.281 3.493.98.109-.762.419-1.282.762-1.577-2.665-.297-5.467-1.31-5.467-5.827 0-1.287.468-2.34 1.236-3.164-.124-.298-.536-1.498.118-3.12 0 0 1.007-.318 3.3 1.208A11.685 11.685 0 0 1 12 5.702c1.02.005 2.046.135 3.005.397C17.295 4.573 18.3 4.89 18.3 4.89c.655 1.623.243 2.823.12 3.12.77.824 1.233 1.878 1.233 3.165 0 4.53-2.806 5.526-5.478 5.818.43.364.814 1.084.814 2.184 0 1.576-.015 2.847-.015 3.234 0 .315.217.682.825.567C20.565 21.416 24 17 24 11.791 24 5.28 18.627 0 11.999 0"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
)

const Discord = ({ className }) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path
            // eslint-disable-next-line max-len
            d="M12 0c6.6 0 12 5.4 12 12s-5.4 12-12 12S0 18.6 0 12 5.4 0 12 0zm-1.9 6.8c-.3 0-1.8.1-3.4 1.3 0 0-1.8 3.2-1.8 7.1 0 0 1 1.8 3.7 1.9 0 0 .3-.3.6-.7l.1-.1.1-.1V16c-1.5-.5-2.1-1.4-2.1-1.4s.1.1.3.2h.1s.1 0 .1.1c.3.2.6.3.9.4.5.2 1.1.4 1.8.5 1 .2 2.1.2 3.2 0 .6-.1 1.2-.3 1.8-.5.4-.2.9-.4 1.4-.7-.1.1-.7 1-2.2 1.4l.1.1.1.1c.3.4.7.9.7.9 2.7-.1 3.7-1.9 3.7-1.9 0-3.9-1.8-7.1-1.8-7.1-1.6-1.2-3.1-1.3-3.4-1.3l-.3.2c1.6.5 2.5 1.2 2.9 1.4l.1.1c-1.9-1-4-1.4-6.1-1.1h-.2c-.4 0-1.5.2-2.8.8-.4.2-.7.4-.7.4s1.1-1 3.2-1.6l-.1-.2zm-.3 4.6c.7 0 1.3.6 1.2 1.4 0 .7-.5 1.4-1.2 1.4s-1.2-.6-1.2-1.4c-.1-.8.5-1.4 1.2-1.4zm4.4 0c.7 0 1.2.6 1.2 1.4 0 .7-.5 1.4-1.2 1.4s-1.2-.6-1.2-1.4c0-.8.5-1.4 1.2-1.4z"
            fill="currentColor"
        />
    </svg>
)

const Trello = ({ className }) => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className}>
        {/* eslint-disable-next-line max-len */}
        <path
            d="M21 0a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h18zm-1.56 3.12H15a1.44 1.44 0 0 0-1.44 1.44v7.62c0 .795.645 1.44 1.44 1.44h4.44a1.44 1.44 0 0 0 1.44-1.44V4.56a1.44 1.44 0 0 0-1.44-1.44zM9 3.12H4.56a1.44 1.44 0 0 0-1.44 1.44v13.62c0 .795.645 1.44 1.44 1.44H9a1.44 1.44 0 0 0 1.44-1.44V4.56A1.44 1.44 0 0 0 9 3.12z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
)

const Twitter = ({ className }) => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className}>
        {/* eslint-disable-next-line max-len */}
        <path
            d="M7.539 21.592c9.056 0 14.012-7.54 14.012-14.067 0-.212 0-.425-.01-.637A10.055 10.055 0 0 0 24 4.324a9.95 9.95 0 0 1-2.833.78 4.97 4.97 0 0 0 2.17-2.738 9.773 9.773 0 0 1-3.13 1.196A4.906 4.906 0 0 0 16.614 2c-2.718 0-4.927 2.218-4.927 4.946 0 .386.048.762.125 1.128C7.72 7.872 4.09 5.895 1.66 2.906A4.96 4.96 0 0 0 1 5.394c0 1.716.874 3.23 2.19 4.117a4.966 4.966 0 0 1-2.23-.617v.067a4.95 4.95 0 0 0 3.948 4.85 4.784 4.784 0 0 1-1.297.174c-.317 0-.624-.03-.922-.087a4.927 4.927 0 0 0 4.6 3.432 9.853 9.853 0 0 1-6.117 2.121A9.44 9.44 0 0 1 0 19.384a13.968 13.968 0 0 0 7.539 2.208"
            fill="currentColor"
        />
    </svg>
)

const Youtube = ({ className }) => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className}>
        {/* eslint-disable-next-line max-len */}
        <path
            d="M23.498 6.64C24 8.524 24 12.455 24 12.455s0 3.93-.502 5.814a3.016 3.016 0 0 1-2.121 2.135c-1.872.505-9.377.505-9.377.505s-7.505 0-9.377-.505A3.016 3.016 0 0 1 .501 18.27C0 16.385 0 12.455 0 12.455s0-3.93.501-5.815a3.015 3.015 0 0 1 2.122-2.135C4.495 4 12 4 12 4s7.505 0 9.377.505a3.015 3.015 0 0 1 2.121 2.135zM9.545 16.023l6.273-3.568-6.273-3.569v7.137z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
)

const LinkedIn = ({ className }) => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className}>
        {/* eslint-disable-next-line max-len */}
        <path
            d="M2.87 5.351c1.791 0 2.906-1.19 2.906-2.676C5.743 1.157 4.661 0 2.906 0 1.147 0 0 1.157 0 2.675c0 1.486 1.114 2.676 2.838 2.676h.033zM.304 22.95V7.465h5.135v15.484H.303zM8 22.847S8.067 8.816 8 7.364h5.135v2.245H13.1C13.776 8.552 14.992 7 17.763 7c3.378 0 5.911 2.213 5.911 6.97v8.877H18.54v-8.283c0-2.081-.743-3.502-2.602-3.502-1.418 0-2.263.958-2.634 1.883-.136.33-.17.793-.17 1.255v8.647H8z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
)

const Blog = ({ className }) => (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className}>
        {/* eslint-disable-next-line max-len */}
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.0056 1.10924V0.417315C15.0056 0.180097 14.8078 -0.0107865 14.5708 0.000473859C9.91888 0.221426 6.19092 3.96995 6.00339 8.62988C6.0134 8.92194 6.24978 8.99839 6.3888 8.99839H7.09163C7.31403 8.99839 7.49635 8.82381 7.5079 8.60173C7.70753 4.76809 10.7837 1.69569 14.6192 1.50131C14.9117 1.46373 15.0056 1.30388 15.0056 1.10924ZM8.67923 8.99839H9.35182C9.57018 8.99839 9.7482 8.82823 9.76409 8.61049C9.95421 6.00594 12.0429 3.92837 14.6525 3.75525C14.7692 3.74753 15.0056 3.66016 15.0056 3.3578V2.67301C15.0056 2.43104 14.8003 2.24099 14.5588 2.25675C11.1829 2.47704 8.48327 5.1763 8.26291 8.55177C8.24719 8.7932 8.43722 8.99839 8.67923 8.99839ZM17.6181 15.0016C17.7572 15.0016 17.9935 15.0781 18.0036 15.3701C17.816 20.0301 14.0881 23.7785 9.43613 23.9995C9.19913 24.0108 9.00138 23.8199 9.00138 23.5826V22.8908C9.00138 22.6961 9.09523 22.5363 9.38774 22.4987C13.2233 22.3043 16.2994 19.2319 16.499 15.3983C16.5106 15.1762 16.6929 15.0016 16.9153 15.0016H17.6181ZM15.3277 15.0016C15.5697 15.0016 15.7598 15.2068 15.744 15.4482C15.5237 18.8237 12.8241 21.523 9.4481 21.7433C9.20659 21.759 9.00138 21.569 9.00138 21.327V20.6422C9.00138 20.3398 9.23775 20.2525 9.35446 20.2447C11.9641 20.0716 14.0528 17.9941 14.2429 15.3895C14.2587 15.1717 14.4368 15.0016 14.6551 15.0016H15.3277ZM13.068 15.0016C13.3129 15.0016 13.5079 15.2118 13.4835 15.4555C13.2709 17.5806 11.5808 19.2704 9.4554 19.4831C9.21168 19.5075 9.00138 19.3125 9.00138 19.0676V18.3797C9.00138 18.0982 9.2458 17.9969 9.36497 17.9826C10.7303 17.8178 11.8134 16.7371 11.9818 15.3732C12.0079 15.1621 12.1836 15.0016 12.3964 15.0016H13.068ZM1.1094 8.99659C1.30407 8.99659 1.46394 9.09043 1.50152 9.38291C1.69598 13.2179 4.76878 16.2936 8.60297 16.4932C8.82509 16.5047 8.99973 16.687 8.99973 16.9094V17.6122C8.99973 17.7512 8.92323 17.9875 8.63117 17.9975C3.97056 17.81 0.2215 14.0825 0.000473926 9.43128C-0.010788 9.19432 0.180123 8.99659 0.417417 8.99659H1.1094ZM3.35833 8.99659C3.66073 8.99659 3.74807 9.23294 3.75583 9.34963C3.92893 11.9589 6.0068 14.0473 8.61173 14.2373C8.82955 14.2532 8.99973 14.4312 8.99973 14.6495V15.322C8.99973 15.564 8.79451 15.754 8.55301 15.7383C5.17705 15.5179 2.47739 12.8187 2.25708 9.44326C2.24131 9.20178 2.43139 8.99659 2.67339 8.99659H3.35833ZM15.3688 5.98341C20.0295 6.17091 23.7785 9.89833 23.9995 14.5496C24.0108 14.7866 23.8198 14.9843 23.5826 14.9843H22.8906C22.6959 14.9843 22.5361 14.8904 22.4985 14.598C22.304 10.763 19.2312 7.6873 15.397 7.4877C15.1749 7.47615 15.0003 7.29386 15.0003 7.07149V6.36872C15.0003 6.22972 15.0767 5.99338 15.3688 5.98341ZM15.447 8.24261C18.823 8.46289 21.5226 11.1622 21.7429 14.5376C21.7587 14.7791 21.5686 14.9843 21.3266 14.9843H20.6417C20.3393 14.9843 20.2519 14.7479 20.2442 14.6313C20.0711 12.022 17.9932 9.93361 15.3883 9.74356C15.1705 9.72768 15.0003 9.54968 15.0003 9.33135V8.65886C15.0003 8.41689 15.2055 8.22684 15.447 8.24261ZM15.4543 10.5027C17.5797 10.7154 19.2698 12.4052 19.4824 14.5303C19.5068 14.774 19.3118 14.9843 19.0669 14.9843H18.3789C18.0973 14.9843 17.9961 14.7399 17.9817 14.6207C17.8169 13.2557 16.7361 12.1726 15.3719 12.0043C15.1608 11.9782 15.0003 11.8025 15.0003 11.5898V10.9182C15.0003 10.6733 15.2106 10.4784 15.4543 10.5027ZM5.62114 8.99659C5.90269 8.99659 6.00393 9.24099 6.01832 9.36014C6.18312 10.7252 7.26393 11.8082 8.62808 11.9766C8.83922 12.0026 8.99973 12.1783 8.99973 12.3911V13.0627C8.99973 13.3075 8.78942 13.5025 8.5457 13.4782C6.42028 13.2654 4.73024 11.5756 4.51752 9.45055C4.49316 9.20687 4.68815 8.99659 4.93308 8.99659H5.62114ZM15.0056 4.93237V5.62029C15.0056 5.9018 14.7612 6.00306 14.642 6.01745C13.2767 6.18218 12.1935 7.26284 12.0252 8.6268C11.9991 8.83795 11.8234 8.99839 11.6106 8.99839H10.9389C10.694 8.99839 10.499 8.78811 10.5234 8.54443C10.7361 6.41936 12.4262 4.72956 14.5515 4.51686C14.7953 4.49251 15.0056 4.68748 15.0056 4.93237Z"
            fill="currentColor"
        />
    </svg>
)

const channels = {
    github: {
        url: 'https://github.com/streamr-dev',
        name: 'GitHub',
        icon: GitHub,
    },
    linkedIn: {
        url: 'https://www.linkedin.com/company/streamr-network/',
        name: 'LinkedIn',
        icon: LinkedIn,
    },
    blog: {
        url: 'https://blog.streamr.network',
        name: 'Streamr Blog',
        icon: Blog,
    },
    trello: {
        url: 'https://trello.com/b/nQQ9Zwvj/streamr-milestone-2',
        name: 'Trello',
        icon: Trello,
    },
    twitter: {
        url: 'https://twitter.com/streamr',
        name: 'Twitter',
        icon: Twitter,
    },
    youtube: {
        url: 'https://www.youtube.com/channel/UCGWEA61RueG-9DV53s-ZyJQ',
        name: 'Youtube',
        icon: Youtube,
    },
    discord: {
        url: 'https://discord.gg/gZAm8P7hK8',
        name: 'Discord',
        icon: Discord,
    },
}

export const lineup = ['github', 'discord', 'twitter', 'youtube', 'blog', 'linkedIn']

export default function SocialLink({ className, channelKey }) {
    const { icon: Icon, name, url } = channels[channelKey]

    return (
        <Root href={url} target="_blank" rel="noopener noreferrer" className={className}>
            <Icon />
            <Wrap>
                <Label>{name}</Label>
            </Wrap>
        </Root>
    )
}

const Wrap = styled.div`
    align-items: center;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    transition: 200ms;
    transition-property: opacity, bottom;
    width: 100%;
`

const Root = styled.a`
    box-sizing: content-box;
    display: block;
    font-family: 'IBM Plex Mono', monospace; /* mono */
    font-weight: 400; /* regular */
    line-height: 1.5em;
    margin: -1em;
    padding: 1em;
    position: relative;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    width: 1.5em;

    svg {
        display: block;
        font-size: 1.5em;
        line-height: 1em;
        position: relative;
        top: 0;
        transition: 200ms top;
        transform: translateZ(0);
    }

    &,
    &:link,
    &:active,
    &:focus,
    &:hover,
    &:visited {
        color: inherit;
    }

    &:active svg,
    &:hover svg {
        top: -0.25em;
    }

    &:active ${Wrap}, &:hover ${Wrap} {
        bottom: -0.25em;
        opacity: 1;
    }

    @media ${MqDesktop} {
        width: 2rem;

        svg {
            width: 2rem;
        }
    }
`

const Label = styled.div`
    font-size: 0.75em;
    letter-spacing: 1px;
    white-space: nowrap;
`
